// extracted by mini-css-extract-plugin
module.exports = {"sale-product-list":"style_sale-product-list__VkvCt","sub-products-grid":"style_sub-products-grid__IpNlw"};